import t, { useCallback as h, useEffect as u } from "react";
import { useSalesTermsAndConditions as f } from "./index102.mjs";
import { StripeContainer as E } from "./index244.mjs";
import { VgsContainer as I } from "./index245.mjs";
import { WithoutCardContainer as g } from "./index246.mjs";
import { Dropdown as N } from "./index195.mjs";
import { usePayment as A } from "./index123.mjs";
import { PaymentType as m } from "./index232.mjs";
import a from "./index247.mjs";
import { insuranceSelectedAtom as b } from "./index62.mjs";
import { useAtomValue as C } from "jotai";
const Z = ({
  cartItems: l,
  giftCards: p
}) => {
  var c;
  const { salesTermsAndConditions: e } = f(), { setPayment: i, payment: r } = A(), o = C(b), d = h(
    (n) => n == m.CREDIT_CARD && (e != null && e.amenitiz_pay_at_checkout) ? m.AMENITIZ_PAY : n,
    [e]
  );
  if (u(() => {
    var n;
    e && ((e == null ? void 0 : e.payment_methods.length) === 1 || o) && i({
      payment_method: d(
        ((n = e.payment_methods[0]) == null ? void 0 : n[0]) ?? ""
      )
    });
  }, [
    e,
    d,
    i,
    o
  ]), !e)
    return null;
  const s = o ? !1 : e.payment_methods.length > 1, y = () => {
    switch (r.payment_method) {
      case m.AMENITIZ_PAY:
        return /* @__PURE__ */ t.createElement(
          E,
          {
            cartItems: l,
            giftCards: p,
            optedForInsurance: o
          }
        );
      case m.CREDIT_CARD:
        return /* @__PURE__ */ t.createElement(
          I,
          {
            cartItems: l,
            giftCards: p,
            optedForInsurance: o
          }
        );
      case void 0:
        return null;
      case null:
        return null;
      default:
        return /* @__PURE__ */ t.createElement(
          g,
          {
            cartItems: l,
            paymentType: r.payment_method,
            giftCards: p
          }
        );
    }
  };
  return /* @__PURE__ */ t.createElement("div", { className: a["payment-selector"], "data-testid": "payment-selector" }, s ? /* @__PURE__ */ t.createElement(
    "div",
    {
      className: a["payment-details"],
      "data-testid": "payment-dropdown"
    },
    /* @__PURE__ */ t.createElement("div", { className: a["expanded-header"] }, /* @__PURE__ */ t.createElement("h3", { className: a["expanded-header-title"] }, I18n.t("booking_engine.information.payment_method")), /* @__PURE__ */ t.createElement(
      N,
      {
        id: "payment-method",
        name: "payment-method",
        label: I18n.t("booking_engine.information.payment_method.label"),
        placeholder: I18n.t(
          "booking_engine.information.select_payment_method"
        ),
        selectedOption: ((c = r.payment_method) == null ? void 0 : c.toString()) == m.AMENITIZ_PAY ? m.CREDIT_CARD : r.payment_method,
        onChange: (n) => {
          i({
            payment_method: d(n)
          });
        },
        options: e.payment_methods.map(([n, _]) => ({
          label: _,
          value: n
        }))
      }
    ))
  ) : /* @__PURE__ */ t.createElement(
    "div",
    {
      className: a["payment-details"],
      "data-testid": "no-payment-selector"
    },
    /* @__PURE__ */ t.createElement("div", { className: a["expanded-header"] }, /* @__PURE__ */ t.createElement("h3", { className: a["expanded-header-title"] }, I18n.t("booking_engine.complete_payment_details")))
  ), y());
};
export {
  Z as PaymentSelector
};
